import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

type SubmitButtonProps = {
	variant?: 'default' | 'warning' | 'destructive';
	icon?: React.ReactNode;
	isSubmitting: boolean;
	children: React.ReactNode;
	fullWidth?: boolean;
	className?: string;
	onClick?: () => void;
};

export default function SubmitButton({
	variant,
	icon,
	isSubmitting,
	children,
	fullWidth,
	className,
	onClick,
}: SubmitButtonProps) {
	return (
		<Button
			type="submit"
			variant={variant || 'default'}
			className={`${fullWidth ? 'w-full' : 'flex min-w-[100px]'} ${className && className}`}
			disabled={isSubmitting}
			onClick={onClick || undefined}
		>
			{isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
			{!isSubmitting && icon && <div className="mr-2">{icon}</div>}
			{children}
		</Button>
	);
}
